define('components/tags/entityTag/model', [
], function () {
    function Model(jsonModel) {
        this.tag = ko.observable(jsonModel.tag).unwrap();
        this.manager = ko.observable(jsonModel.manager).unwrap();
    }

    return Model;
});